import * as _ from 'lodash';
import { Button, FormControl, Well } from 'react-bootstrap';
import { IHardToMatchPair } from '@nkr/models/hard-to-match/hard-to-match-pair';
import { styles } from './styles';

export interface IHardToMatchFilters {
    recipientCenterId: number;
    donorCenterId: number;
    recipientBloodType: string;
    search: string;
    showHidden: boolean;
}

export const defaultHardToMatchFilters: IHardToMatchFilters = {
    recipientCenterId: 0,
    donorCenterId: 0,
    recipientBloodType: '',
    search: '',
    showHidden: false
};

interface IProps {
    data: IHardToMatchPair[];
    filters: IHardToMatchFilters;
    onChange: (filters: IHardToMatchFilters) => void;
    onReset: () => void;
}

const FilterBar = (props: IProps) => {
    const { data, filters } = props;

    const recipientCenters = _.sortBy(_.uniqBy(data.map(x => ({ id: x.recipientCenterId, alias: x.recipientCenterAlias })), 'id'), 'alias');
    const donorCenters = _.sortBy(_.uniqBy(data.map(x => ({ id: x.donorCenterId, alias: x.donorCenterAlias })), 'id'), 'alias');
    const bloodTypes = _.uniq(data.map(x => x.recipientBloodType)).sort();

    const handle = (field: keyof IHardToMatchFilters, value: string | number | boolean) => props.onChange({ ...filters, [field]: value });

    return (
        <Well bsSize='sm' style={styles.filterWell}>
            <div style={styles.filterItem}>
                <div style={styles.filterLabel}>Recipient Center:</div>
                <FormControl componentClass='select' style={styles.select} value={filters.recipientCenterId} onChange={e => handle('recipientCenterId', parseInt((e as any).currentTarget.value))}>
                    <option value={0}>- ALL -</option>
                    {recipientCenters.map(c => <option key={c.id} value={c.id}>{c.alias}</option>)}
                </FormControl>
            </div>

            <div style={styles.filterItem}>
                <div style={styles.filterLabel}>Donor Center:</div>
                <FormControl componentClass='select' style={styles.select} value={filters.donorCenterId} onChange={e => handle('donorCenterId', parseInt((e as any).currentTarget.value))}>
                    <option value={0}>- ALL -</option>
                    {donorCenters.map(c => <option key={c.id} value={c.id}>{c.alias}</option>)}
                </FormControl>
            </div>

            <div style={styles.filterItem}>
                <div style={styles.filterLabel}>Recipient ABO:</div>
                <FormControl componentClass='select' value={filters.recipientBloodType} onChange={e => handle('recipientBloodType', (e as any).currentTarget.value)}>
                    <option value=''>- ALL -</option>
                    {bloodTypes.map(b => <option key={b} value={b}>{b}</option>)}
                </FormControl>
            </div>

            <div style={styles.filterItem}>
                <div style={styles.filterLabel}>Search:</div>
                <FormControl style={styles.searchInput} value={filters.search} placeholder='Alias, center or avoid...' onChange={e => handle('search', (e as any).currentTarget.value)} />
            </div>

            <div style={styles.checkboxItem}>
                <label style={styles.checkboxLabel}>
                    <input type='checkbox' style={styles.checkboxInput} checked={filters.showHidden} onChange={() => handle('showHidden', !filters.showHidden)} />
                    Show Hidden
                </label>
            </div>

            <div style={styles.buttonRow}>
                <Button bsStyle='primary' onClick={props.onReset}>Reset Filters</Button>
            </div>
        </Well>
    );
};

export default FilterBar;
